var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"list"},[_c('div',{staticClass:"row"},_vm._l((_vm.fruits),function(fruit){return _c('article',{key:fruit.code,staticClass:"card fruit-card",on:{"click":function($event){return _vm.selectFruit(fruit.code)}}},[_c('h3',[_vm._v(_vm._s(fruit.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }